export default "__VITE_ASSET__fa98370e__"